<template>
  <div>
    <div class="max-w-sm">
      <Input
        :label="label"
        @change="input"
      />
    </div>
  </div>
</template>

<script>
import { minLength, required } from 'vuelidate/lib/validators';
import Input from '@/app/shared/components/form/inputs/input.vue';

export default {

  components: {
    Input,
  },

  props: {
    label: {
      type: String,
      default: 'Phone Number',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      number: '',
    };
  },

  mounted() {
    this.$emit('errors', this.getErrors());
  },

  methods: {
    input(input) {
      this.number = input;
      this.$emit('input', input);
      this.$emit('errors', this.getErrors());
    },

    getErrors() {
      const errors = [];

      if (this.required) {
        if (!this.$v.number.required) {
          errors.push('A phone number is required.');
        }
      }

      if (!this.$v.number.minLength) {
        errors.push('A valid phone number is required.');
      }

      return errors;
    },
  },

  validations() {
    return {
      number: { required, minLength: minLength(9) },
    };
  },
};
</script>
